// extracted by mini-css-extract-plugin
module.exports = {"section_lead":"RankingShortColumn_section_lead__W35wU","container":"RankingShortColumn_container__q6hW5","column_wrapper":"RankingShortColumn_column_wrapper__UC8mV"};